import { defineComponent as _defineComponent } from 'vue'
import FireSolidIcon from '~/assets/img/FireSolidIcon.svg'


export default /*#__PURE__*/_defineComponent({
  __name: 'HotlistStatusSelectorPopupToggleButtonMobile',
  props: {
    isLoading: { type: Boolean },
    isPopupOpen: { type: Boolean },
    isHotlistActive: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'click'): void
}), expose: any, slots: any, attrs: any }) {





return { __sfc: true,emit, FireSolidIcon }
}

})